import { useEffect, useState } from "react";
import {
  EMPTY_REDDICKS_DEX_ANALYTICS,
  fetchReddicksDexAnalyticsSnapshot,
  getCachedReddicksDexAnalyticsSnapshot,
} from "../services/reddicksDexAnalytics";

export const useReddicksDexAnalytics = () => {
  const initialSnapshot = getCachedReddicksDexAnalyticsSnapshot();
  const [snapshot, setSnapshot] = useState(initialSnapshot);
  const [isLoading, setIsLoading] = useState(() => !initialSnapshot);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const loadSnapshot = async () => {
      try {
        const freshSnapshot = await fetchReddicksDexAnalyticsSnapshot();
        if (!isMounted) {
          return;
        }

        setSnapshot(freshSnapshot);
        setError(null);
      } catch (loadError) {
        if (!isMounted) {
          return;
        }

        const cachedSnapshot = getCachedReddicksDexAnalyticsSnapshot({
          allowExpired: true,
        });
        if (cachedSnapshot) {
          setSnapshot(cachedSnapshot);
        }

        setError(loadError);
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    loadSnapshot();

    return () => {
      isMounted = false;
    };
  }, []);

  return {
    overview:
      snapshot?.overview || EMPTY_REDDICKS_DEX_ANALYTICS.overview,
    trendRows:
      snapshot?.trendRows || EMPTY_REDDICKS_DEX_ANALYTICS.trendRows,
    tokenMarkets:
      snapshot?.tokenMarkets || EMPTY_REDDICKS_DEX_ANALYTICS.tokenMarkets,
    topPairs:
      snapshot?.topPairs || EMPTY_REDDICKS_DEX_ANALYTICS.topPairs,
    lastUpdated: snapshot?.lastUpdated || null,
    isLoading,
    error,
    hasCachedData: Boolean(snapshot),
    isFresh: Boolean(snapshot?.isFresh),
  };
};

export default useReddicksDexAnalytics;
